import PropTypes from "prop-types";
import React from "react";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";

function TrackedButton({
    children,
    className,
    eventAction,
    eventCategory,
    eventLabel,
    href,
    openInNewTab,
}) {
    let onClick = useClickTracker(eventCategory, eventAction, eventLabel, !openInNewTab);

    return (
        <a
            className={className}
            href={href}
            onClick={onClick}
            target={openInNewTab ? "_blank" : null}
        >
            {children}
        </a>
    );
}

export default TrackedButton;

TrackedButton.propTypes = {
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    openInNewTab: PropTypes.bool,
    eventCategory: PropTypes.string.isRequired,
    eventAction: PropTypes.string.isRequired,
    eventLabel: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    productId: PropTypes.number,
    reason: PropTypes.string,
};

TrackedButton.defaultProps = {
    openInNewTab: false,
};
